import { CalendarItem } from '@wui/common-library'
import { unix } from 'dayjs'

/**
 * WuiCalendar groups events and formats time via `new Date(timestamp * 1000)` (browser local TZ).
 * Remap timestamp so day and wall-clock match the user-selected timezone.
 */
export const mapCalendarItemForDisplay = (item: CalendarItem, timezone: string): CalendarItem => {
  // Birthdays and other full-day events are calendar dates, not moments in time — no TZ shift.
  if (item.fullDay) {
    return item
  }

  const inUserTz = unix(item.timestamp).tz(timezone)
  const displayDate = new Date(
    inUserTz.year(),
    inUserTz.month(),
    inUserTz.date(),
    inUserTz.hour(),
    inUserTz.minute(),
    inUserTz.second(),
  )

  return {
    ...item,
    timestamp: Math.floor(displayDate.getTime() / 1000),
  }
}
